import type { Reducer } from "@reduxjs/toolkit"

import {
  loadNotificationsAsync,
  setNotificationReadStatusAsync,
} from "@/base/farmhq-api"
import { loadActiveFarmAsync } from "@/base/load-app"
import * as Models from "@/redux/models"
import { createSelector, createSlice, isAnyOf } from "@reduxjs/toolkit"

import { signOutAsync } from "./auth.reducer"

export type NotificationState = Models.ModelState<Models.NotificationEntity>

const initialState: NotificationState = Models.getInitialEntityState()

const slice = createSlice({
  extraReducers: (builder) =>
    builder
      .addCase(loadActiveFarmAsync.fulfilled, (state, { payload }) => {
        Models.appNotifications.adapter.setAll(state, payload.appNotifications ?? [])
      })
      .addCase(loadNotificationsAsync.fulfilled, (state, { payload }) => {
        Models.appNotifications.adapter.setAll(state, payload.items)
      })
      .addCase(setNotificationReadStatusAsync.pending, (state, { meta }) => {
        Models.appNotifications.adapter.updateMany(
          state,
          meta.arg.ids.map((id) => ({ changes: { readStatus: "seen" }, id })),
        )
      })
      .addMatcher(isAnyOf(signOutAsync.fulfilled), () => {
        return { ...initialState }
      }),

  initialState,
  name: "appNotifications",
  reducers: {},
})
const appNotifications: Reducer<NotificationState> = slice.reducer

export default appNotifications

export const getUnreadNotificationsFromState = createSelector(
  Models.appNotifications.selectAll,
  (values) => values.filter((value) => value.readStatus !== "seen"),
)
export const getNumUnreadNotificationsFromState = createSelector(
  getUnreadNotificationsFromState,
  (items) => items.length,
)
